module.exports = __webpack_public_path__ + "img/title-2.54794d94.png";